import { render, staticRenderFns } from "./Themes.vue?vue&type=template&id=35915bb8&scoped=true&"
import script from "./Themes.vue?vue&type=script&lang=ts&"
export * from "./Themes.vue?vue&type=script&lang=ts&"
import style0 from "./Themes.vue?vue&type=style&index=0&id=35915bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35915bb8",
  null
  
)

export default component.exports